import './Logo.scss';

function Logo() {
  return (
    <h2 className="app-logo"><b>Optibin</b></h2>
  );
}
export default Logo;

